// Resume content (single source for the Resume section)
export const experience = [
  { tag: "2020 – Present", title: "Founder & CTO", subtitle: "Workflox Pvt Ltd", detail: "Architecting AI SaaS platforms and agentic workflows for clients across the Gulf and Pakistan." },
  { tag: "Impact Case", title: "Cabz (Croatia)", subtitle: "Taxi Ecosystem", detail: "Scaled to 1,000+ active users in the first month through automated dispatch." },
  { tag: "Impact Case", title: "Kavan AI", subtitle: "Healthcare Platform", detail: "Cut appointment scheduling wait times by 40% with n8n-orchestrated AI workflows." },
  { tag: "Impact Case", title: "AI Sales Agents", subtitle: "Lead Generation", detail: "Autonomous chatbots qualifying inbound traffic 24/7 with full CRM synchronisation." },
];

export const education = [
  { tag: "2018 – 2020", title: "Master of Computer Science (MSCS)", subtitle: "University of Engineering and Technology, Lahore" },
  { tag: "2011 – 2015", title: "Bachelor of Computer Science (BCompSc)", subtitle: "The University of Lahore" },
];

export const skillGroups = [
  { title: "AI & LLM Engineering", items: ["GPT-5 / Claude", "Prompt & Context Engineering", "RAG Systems", "AI Agents", "Python & Agentic Workflows"] },
  { title: "Automation & No-Code", items: ["n8n (Advanced)", "Make / Zapier", "Business Process Automation", "Web Scraping & Data Pipelines"] },
  { title: "Full-Stack Product", items: ["React Native / Flutter", "Next.js / Node.js", "Firebase / Supabase", "SaaS MVP Delivery"] },
];

export const aboutMe = {
  facts: [
    ["Name", "Sami"],
    ["Based in", "Lahore, Pakistan (GMT+5)"],
    ["Experience", "10+ years"],
    ["Role", "Fractional CTO & AI Product Builder"],
    ["Languages", "English, French, Spanish (fluent)"],
  ],
  achievements: [
    "Scaled Cabz to 1,000+ active users in its first month.",
    "Reduced healthcare scheduling wait times by 40% with AI orchestration.",
    "Built AI lead engines generating $20k+ in monthly ROI for clients.",
  ],
  funFacts:
    "I align technical strategy with business ROI. I've automated 15+ hours of manual work per week for multiple founders, and I believe in zero-touch operations — agents handle the repetition so people handle the creativity. I speak three languages and build with AI-assisted workflows that ship at 10x speed.",
};
